// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__23xx_","largestCol":"styles_largestCol__2NojF","smallestCol":"styles_smallestCol__XUpt6"};